"use strict";
APP.ui.TimerUI = function ( p_type, p_seconds, p_callbackComplete, p_callbackTick ) {

    // Invoke (needed)
    EHDI.aka.Container.call( this );

    // Properties

    // ** Parent (This reference)
    var _parent = this;

    // ** General Values
    var _callbackComplete, _callbackTick, _currentTime, _endTime, _tickTime, _isComplete, _isPaused, _isUpdateActive, _isWarningActive, _type;

    // ** Graphics
    var _sprBG, _sprFlash, _sprLine, _sprSparkle, _txtHeader, _txtValue, _timelineShake, _timelineUpdate;

    // Private Methods

    // ** General Methods
    
    var _getConvertedTime = function () {

        var result = "";

        if ( _currentTime && _txtValue ) {

            var timeInSecs = Math.round( _currentTime / 1000 );
            var minutes = Math.floor( timeInSecs / 60 );
            var seconds = Math.round( timeInSecs % 60 );

            var strMins, strSecs;
            
            if ( minutes < 10 ) strMins = "0" + minutes.toString();
            else strMins = minutes.toString();

            if ( seconds < 10 ) strSecs = "0" + seconds.toString();
            else strSecs = seconds.toString();

            var str = strMins + ":" + strSecs;
            if ( _txtValue.text !== str ) _txtValue.text = str; 
        }

        return result;
    };

    var _setValue = function ( p_value, p_addValue ) {
        
        // Check if param values are invalid, then throw error
        if ( typeof p_value !== "number" ) throw "Time value for time ui is not valid. Must be number.";
        if ( p_value <= 0 ) throw "Time value for time ui is not valid. Must be greater than zero.";

        // Check if some propeties are invalid, then return
        if ( !_txtValue ) return;
        if ( !_timelineUpdate ) return;

        // Set value
        if ( p_addValue === true ) _currentTime += p_value;
        else _currentTime = p_value;

        // Convert time
        _getConvertedTime();

        // Start animation
        _isUpdateActive = true;
        _timelineUpdate.restart();
        _timelineUpdate.play();
    };

    var _toggleEffects = function( p_value ) {
        
        // Check if param values are invalid, then throw error
        if ( p_value !== true &&
            p_value !== false ) throw "Value must be boolean.";
        
        // Toggle
        if ( _sprLine ) _sprLine.visible = p_value;
        if ( _sprSparkle ) _sprSparkle.visible = p_value;
    };
    
    var _toggleFlash  = function( p_value ) {

        // Check if param values are invalid, then throw error
        if ( p_value !== true &&
            p_value !== false ) throw "Value must be boolean.";
        
        // Toggle
        if ( _sprFlash ) _sprFlash.visible = p_value;
    };

    var _updateTime = function ( p_delta ) {

        // Check values if invalid, then retun
        if ( !_type ) return;

        if ( typeof _currentTime !== "number" ) return;
        if ( typeof _endTime !== "number" ) return;

        if ( _isComplete === true ) return;
        if ( _isPaused === true ) return;

        // Do according to value 
        if ( _type === APP.ui.TimerType.COUNTDOWN ) {

            _currentTime -= p_delta;
            _currentTime = Math.max( 0, _currentTime );

            if ( _currentTime <= _endTime ) _isComplete = true;
        }
        else if ( _type === APP.ui.TimerType.COUNTUP ) {

            _currentTime += p_delta;
            _currentTime = Math.min( 0, _endTime );

            if ( _currentTime <= _endTime ) _isComplete = true;
        }

        // Update tick time
        _tickTime -= p_delta;

        if ( _tickTime <= 0 ) {

            // Reset tick time, add one seconds in case tick goes over a second
            _tickTime += 1000;

            // Call tick callback
            if ( _callbackTick ) _callbackTick();
        }

        // Convert time
        _getConvertedTime();

        // If isCallbackCalled, invoke callback
        // Else check for warning
        if ( _isComplete ) {

            if ( _callbackComplete ) _callbackComplete();
        }
        else {
            
            // If text value is empty, return
            if ( !_txtValue ) return;

            // Get difference of current time to end time
            var timeLeft = Math.round( Math.abs( ( _endTime / 1000 ) - ( _currentTime / 1000 ) ) );
            
            // Do time left
            if ( timeLeft > 10 && _isWarningActive ) {

                // Set isWarningActive to false
                _isWarningActive = false;

                // Change style of text field
                _txtValue.style = { fontFamily:'proximanova-black', fill: 0xFFFFFF, fontSize: 36 };
                
                if ( _timelineShake ) {
                    if ( _timelineShake.isActive() ) {
                        _timelineShake.stop();
                        _timelineShake.reset();
                    }
                }
            } 
            else if ( timeLeft < 10 && !_isWarningActive ) {

                // Set warning to true
                _isWarningActive = true;
                
                // Change style of text field
                _txtValue.style = { fontFamily:'proximanova-black', fill: 0xED1C24, fontSize: 36 };
                
                if ( _timelineShake ) {
                    if ( !_timelineShake.isActive() ) {
                        _timelineShake.play();
                    }
                }
            }
        }
    };

    // ** Handlers

    /**
     * Handler for frame update
     * @param {Number} p_delta 
     */
    var _handler_frameUpdate = function ( p_delta ) {

        if(APP.pauseButton)
            {
                if ( APP.pauseButton.isPaused === true || APP.pauseButton.isEndGame === true )
                return;
            }
       // Update time
       _updateTime( p_delta );
    };

    // ** Initialization Methods

    var _initProps = function ( p_type, p_time, p_callbackComplete, p_callbackTick ) {

        // Check if param values are invalid, then throw error
        if ( p_type !== APP.ui.TimerType.COUNTDOWN &&
            p_type !== APP.ui.TimerType.COUNTUP ) throw "Type value for timer ui is invalid.";

        if ( !p_time ) throw "Time value for timer ui is not defined.";
        if ( typeof p_time !== "number" ) throw "Time value for timer ui is not valid. Must be number.";
        if ( p_time <= 0 ) throw "Time value for timer ui is not valid. Must be greater than zero";

        if ( !p_callbackComplete ) throw "Callback complete for timer ui is not defined.";
        if ( !p_callbackTick ) throw "Callback tick for timer ui is not defined.";

        // Initialize properties
        _callbackComplete = p_callbackComplete;
        _callbackTick = p_callbackTick;
        _isComplete = false;
        _isPaused = false;
        _isUpdateActive = false;
        _isWarningActive = false;
        _tickTime = 1000;
        _type = p_type;
        
        // Do according to type
        if ( p_type === APP.ui.TimerType.COUNTDOWN ) {

            _currentTime = p_time * 1000;
            _endTime = 0;
        }
        else if ( p_type === APP.ui.TimerType.COUNTUP ) {

            _currentTime = 0;
            _endTime = p_time * 1000;
        }
            
    };

    var _initGraphics = function () {

        // Initialize graphics
        if ( !_sprBG ) {

             _sprBG = new EHDI.aka.Sprite( EHDI.Assets.images[ "assets/ui/gfx_container.png" ] );

             if ( _parent ) _parent.addChild( _sprBG );
        }
        
        if ( !_txtHeader ) {

            _txtHeader = new EHDI.displays.TextSprite(APP.managers.json.getLocale("STR_CONT_TIMERTITLE"));
            _txtHeader.anchor.set( 0.5, 0.5 );
            _txtHeader.position.set( _sprBG.width * 0.169, _sprBG.height * 0.4 );

            if ( _parent ) _parent.addChild( _txtHeader );
        }

        if ( !_txtValue ) {
            
            _txtValue =  new EHDI.displays.TextSprite(APP.managers.json.getLocale("STR_CONT_TIMERVALUE"));
            _txtValue.anchor.set( 0.5, 0.5 );
            _txtValue.position.set( _sprBG.width * 0.675, _sprBG.height * 0.45 );
            
            if ( _parent ) _parent.addChild( _txtValue );

            // Get converted time
            _getConvertedTime();
        }

        if ( !_sprFlash ) {

            _sprFlash = new EHDI.aka.Sprite( EHDI.Assets.images[ "assets/ui/gfx_container_white.png" ] );
            _sprFlash.alpha = 0;
            _sprFlash.visible = false;

            if ( _parent ) _parent.addChild( _sprFlash );
        }
        
        if ( !_sprSparkle ) {

            _sprSparkle = new EHDI.aka.Sprite( EHDI.Assets.images[ "assets/ui/gfx_flare_star.png" ] );
            _sprSparkle.anchor.set( 0.5, 0.5 );
            _sprSparkle.position.set( _txtHeader.x, _txtHeader.y );
            _sprSparkle.scale.set( 0, 0 );
            _sprSparkle.visible = false;
            if ( _parent ) _parent.addChild( _sprSparkle );
        }

        if ( !_sprLine ) {

            _sprLine = new EHDI.aka.Sprite( EHDI.Assets.images[ "assets/ui/gfx_flare_long.png" ] );
            _sprLine.anchor.set( 0.5, 0.5 );
            _sprLine.position.set( _sprBG.width * 0.5, _sprBG.height * 0.4 );
            _sprLine.scale.set( 0, 1 );
            _sprLine.visible = false;
            if ( _parent ) _parent.addChild( _sprLine );
        }

        if ( !_timelineUpdate ) {

            _timelineUpdate = new TimelineMax( { onComplete: function () { if ( _isUpdateActive === true ) _isUpdateActive = false; } } );
            _timelineUpdate.to( _txtValue.scale, 0.1, { x: 1.5, y : 1.5 } );
            _timelineUpdate.to( _txtValue.scale, 0.1, { x: 1, y : 1 } );
            _timelineUpdate.addCallback( _toggleEffects, "+=0", [ true ] );
            _timelineUpdate.addCallback( _toggleFlash, "+=0", [ true ] );
            _timelineUpdate.to( _sprSparkle.scale, 0.1, { x: 1, y : 1, ease: Power0.easeNone } );
            _timelineUpdate.to( _sprLine.scale, 0.2, { x: 1, y : 1, ease: Power0.easeNone }, "-=0.1" );
            _timelineUpdate.to( _sprFlash, 0.05, { alpha : 0.75 } );
            _timelineUpdate.to( _sprSparkle, 0.15, { x: _parent.width * 0.9, rotation: 5, ease: Power0.easeNone }, "-=0.15" );
            _timelineUpdate.to( _sprFlash, 0.1, { alpha : 0 }, "-=0.025" );
            _timelineUpdate.addCallback( _toggleFlash, "-=0.05", [ false ] );
            _timelineUpdate.addCallback( _toggleEffects, "+=0.025", [ false ] );
            _timelineUpdate.pause();
        }

        if ( !_timelineShake ) {

            _timelineShake = new TimelineMax( { repeat : -1 } );
            _timelineShake.to( _txtValue, 0.05, { x : _sprBG.width * 0.69, ease : Power0.easeNone } );
            _timelineShake.to( _txtValue, 0.1, { x : _sprBG.width * 0.66, ease : Power0.easeNone } );
            _timelineShake.to( _txtValue, 0.05, { x : _sprBG.width * 0.675, ease : Power0.easeNone } );
            _timelineShake.pause();
        }
    };

    var _initListeners = function () {

        // Add frame listeners
        APP.managers.update.addFrameListener( _handler_frameUpdate );
    };

    // ** Kill Methods
    var _killProps = function () {

        _parent = null;
        _callbackComplete = null;
        _currentTime = null;
        _endTime = null;
        _isComplete = null;
        _isPaused = null;
        _isUpdateActive = null;
        _isWarningActive = null;
        _tickTime = null;
        _type = null;
    };

    var _killGraphics = function () {

        if ( _sprBG ) {
            
            if ( _sprBG.parent ) _sprBG.parent.removeChild( _sprBG );

            _sprBG.destroy( { children: true } );
        }
        _sprBG = null;

        if ( _sprFlash ) {
            
            if ( _sprFlash.parent ) _sprFlash.parent.removeChild( _sprFlash );

            _sprFlash.destroy( { children: true } );
        }
        _sprFlash = null;

        if ( _sprLine ) {
            
            if ( _sprLine.parent ) _sprLine.parent.removeChild( _sprLine );

            _sprLine.destroy( { children: true } );
        }
        _sprLine = null;

        if ( _sprSparkle ) {
            
            if ( _sprSparkle.parent ) _sprSparkle.parent.removeChild( _sprSparkle );

            _sprSparkle.destroy( { children: true } );
        }
        _sprSparkle = null;

        if ( _txtHeader ) {
            
            if ( _txtHeader.parent ) _txtHeader.parent.removeChild( _txtHeader );

            _txtHeader.destroy( { children: true } );
        }
        _txtHeader = null;

        if ( _txtValue ) {
            
            if ( _txtValue.parent ) _txtValue.parent.removeChild( _txtValue );

            _txtValue.destroy( { children: true } );
        }
        _txtValue = null;

        if ( _timelineShake ) {

            _timelineShake.stop();
            _timelineShake.kill();
        }
        _timelineShake = null;

        if ( _timelineUpdate ) {

            _timelineUpdate.stop();
            _timelineUpdate.kill();
        }
        _timelineUpdate = null;
    };

    var _killListeners = function () {

        // Remove frame listeners
        APP.managers.update.removeFrameListener( _handler_frameUpdate );
    };

    // Public Methods

    this.destroy = function () {
        
        // Kill listeners
        _killListeners();

        // Kill graphics
        _killGraphics();

        // Kill props
        _killProps();

        // Call superclass method
        APP.ui.TimerUI.prototype.destroy.apply( this, arguments );
    };

    // Call init methods
    _initProps( p_type, p_seconds, p_callbackComplete, p_callbackTick );
    _initGraphics();
    _initListeners();

    // ** Public Methods
    this.setTime = function ( p_value, p_addValue ) { _setValue( p_value, p_addValue ); };

    Object.defineProperties( _parent, {
        "value": {
            get: function () { return _value; },
            enumerable: true
        },
        "paused": {
            get: function () { return _isPaused; },
            set: function ( p_value ) {

                if ( p_value !== true &&
                    p_value !== false ) throw "Pause value should be boolean.";

                if ( _isPaused === p_value ) return;

                // Set isPaused
                _isPaused = p_value;
                
                if ( _isPaused === true ) {

                    if ( _timelineUpdate ) {

                        if ( _timelineUpdate.isActive() && _isUpdateActive === true ) _timelineUpdate.pause();
                    }

                    if ( _timelineShake ) {

                        if ( _timelineShake.isActive() && _isWarningActive === true ) _timelineShake.pause();
                    }

                }
                else if ( _isPaused === false ) {

                    if ( _timelineUpdate ) {

                        if ( !_timelineUpdate.isActive() && _isUpdateActive === true ) _timelineUpdate.play();
                    }
                    
                    if ( _timelineShake ) {

                        if ( !_timelineShake.isActive() && _isWarningActive === true ) _timelineShake.play();
                    }
                }
                
            },
            enumerable: true
        },
        
    });

    

    // Return
    return _parent;
};
APP.ui.TimerUI.prototype = Object.create( EHDI.aka.Container.prototype );
APP.ui.TimerUI.prototype.constructor = APP.ui.TimerUI;